import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import ThankYou from "./pages/ThankYou";
import FormModal from "./components/FormModal";

function App() {
  const [showForm, setShowForm] = useState(false);

  const openModal = () => setShowForm(true);
  const closeModal = () => setShowForm(false);

  return (
    <BrowserRouter>
      {/* <Navbar openModal={openModal} /> */}

      {/* Single Modal Instance */}
      <FormModal show={showForm} closeModal={closeModal} />

      <Routes>
        <Route path="/" element={<Home openModal={openModal} />} />
        <Route path="/thank-you" element={<ThankYou />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
